import { render } from "./Profile.vue?vue&type=template&id=56aec698&scoped=true&ts=true"
import script from "./Profile.vue?vue&type=script&lang=ts"
export * from "./Profile.vue?vue&type=script&lang=ts"

import "./Profile.vue?vue&type=style&index=0&id=56aec698&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56aec698"]])

export default __exports__